import React from 'react';
import Features from './Features';
import Advantages from './Advantages';
import { FAQ } from '../FAQ/faqs';
import Footer from '../Footer';



function BuyingAndVendorPortal() {
  return (
    <>
<Features docname="Buying and Vendor Portal"/>
<Advantages docname="Buying and Vendor Portal"/>
<FAQ category="About Accxchange"/>
<Footer segment="Smarty Home"/>
    </>
  );
}

export default BuyingAndVendorPortal;
